import Checkbox from '@components/checkbox';
import { observer } from 'mobx-react-lite';
import { ChangeEvent } from 'react';

import { DropdownToggle } from 'components/DropdownToggle';
import { TReverseParam, excludeOnlyReverseParams, reverseParams } from 'constants/extraParams';
import { useStore } from 'hooks/useStore';
import { interpolate } from 'utils/string/format';

import { ADR } from '../ADR';

import css from './ReverseParams.module.css';

const ReverseParams = () => {
  const {
    app: { i18n },
    options,
    ui: { isExcludedParamsVisible, toggleIsExcludedParamsVisible },
    filter: {
      extraParams: { reverse },
    },
  } = useStore();

  const params = options.getReverseParams();
  const { exclude, excludeWithCount } = i18n.extraParams.reverse;

  const handleInclude = (event: ChangeEvent<HTMLInputElement>) =>
    reverse.setMode(event.target.value as TReverseParam, 'include');

  const handleExclude = (event: ChangeEvent<HTMLInputElement>) =>
    reverse.setMode(event.target.value as TReverseParam, 'exclude');

  return (
    <div className={css.container}>
      <div className={css.group}>
        {params
          .filter(param => !excludeOnlyReverseParams.includes(param.id))
          .map(param => (
            <Checkbox
              key={param.id}
              checked={reverse.isIncluded(param.id)}
              size="s"
              value={param.id}
              onChange={handleInclude}
            >
              {param.name}
            </Checkbox>
          ))}

        {reverse.isIncluded(reverseParams.adr) && <ADR className={css.ADR} />}
      </div>

      <div className={css.group}>
        <DropdownToggle.DefaultButton
          active={isExcludedParamsVisible}
          classNames={{ button: css.toggle }}
          onClick={toggleIsExcludedParamsVisible}
        >
          {reverse.excludedCount ? interpolate(excludeWithCount, { count: reverse.excludedCount.toString() }) : exclude}
        </DropdownToggle.DefaultButton>

        {isExcludedParamsVisible && (
          <div className={css.group}>
            {params.map(param => (
              <Checkbox
                key={param.id}
                cross={reverse.isExcluded(param.id)}
                size="s"
                value={param.id}
                onChange={handleExclude}
              >
                {param.name}
              </Checkbox>
            ))}

            {reverse.isExcluded(reverseParams.adr) && <ADR className={css.ADR} />}
          </div>
        )}
      </div>
    </div>
  );
};

const connected = observer(ReverseParams);

export { connected as ReverseParams };
